import React, { createContext, useContext, useState, useMemo } from "react";

const dict = {
  el: {
    nav_create: "Νέο καρουζέλ",
    nav_recreate: "Αναδημιουργία",
    nav_history: "Ιστορικό",
    brand_tag: "Carousel Studio",
    hero_kicker: "AI-ΠΟΙΗΤΗΣ ΓΙΑ CREATORS",
    hero_title_1: "Καρουζέλ που σταματούν",
    hero_title_2: "το scroll.",
    hero_sub: "Γράψε το brief — πάρε έτοιμο καρουζέλ Instagram με hooks, captions και CTAs, σε Ελληνικά ή Αγγλικά.",
    cta_create: "Ξεκίνα από το μηδέν",
    cta_recreate: "Αναδημιούργησε post",
    section_latest: "Πρόσφατα καρουζέλ",
    empty_history_title: "Καμία δημιουργία ακόμη.",
    empty_history_sub: "Πάτα \"Ξεκίνα από το μηδέν\" και δες το στούντιο εν δράσει.",
    wizard_step_of: "Βήμα",
    wizard_of: "από",
    wizard_back: "Πίσω",
    wizard_next: "Συνέχεια",
    wizard_generate: "Δημιουργία καρουζέλ",
    generating: "Δημιουργία…",
    // Steps
    step1_title: "Περιέγραψε το προϊόν σου",
    step1_sub: "Όσο πιο συγκεκριμένα, τόσο πιο δυνατό θα βγει το περιεχόμενο.",
    step1_placeholder: "π.χ. Online μαθήματα γιόγκα για επαγγελματίες που δουλεύουν 10+ ώρες και ξυπνάνε με πόνο στη μέση — 15 λεπτά/μέρα, χωρίς εξοπλισμό…",
    step1_price: "Κατηγορία τιμής",
    step1_price_low: "Χαμηλή",
    step1_price_mid: "Μεσαία",
    step1_price_high: "Υψηλή",
    step2_title: "DM trigger & πλήθος slides",
    step2_sub: "Βάλε μια λέξη-κλειδί για σχόλια/DM και πόσα slides θέλεις.",
    step2_keyword: "Λέξη-κλειδί (προαιρετικό)",
    step2_keyword_ph: "π.χ. ΓΙΟΓΚΑ",
    step2_slides: "Πλήθος slides",
    step2_boost: "Ενισχυτής μετατροπών",
    step2_boost_desc: "Σφίγγει το hook και τo CTA.",
    step3_title: "Ποιο είναι το κοινό σου;",
    step3_sub: "Ηλικία, επιθυμίες, πόνος, στάδιο — ό,τι θυμάσαι.",
    step3_placeholder: "π.χ. Επαγγελματίες 30–50 που δουλεύουν WFH, ένιωσαν stress και stiffness μετά το lockdown, ψάχνουν κάτι που μπορούν να κάνουν πριν τη δουλειά…",
    step3_funnel: "Στάδιο στο funnel",
    step3_new: "Νέο κοινό",
    step3_warm: "Με γνωρίζουν ήδη",
    step3_hot: "Έτοιμοι να αγοράσουν",
    step4_title: "Διάλεξε το πλαίσιο σου",
    step4_sub: "15 αποδεδειγμένα ψυχολογικά πλαίσια. Κάθε ένα ακολουθεί δική του δομή μετατροπής.",
    // 15 frameworks (key → label, desc, funnel tag)
    fw_pattern_interrupt: "Διακοπή Μοτίβου",
    fw_pattern_interrupt_d: "Σταματά το scroll με τολμηρή δήλωση",
    fw_myth_busting: "Κατάρριψη Μύθων",
    fw_myth_busting_d: "Καταρρίπτει κοινές παρανοήσεις",
    fw_authority: "Δημιουργός Εξουσίας",
    fw_authority_d: "Χτίζει εμπιστοσύνη και αξιοπιστία",
    fw_soft_story: "Απαλή Αφήγηση-Πώληση",
    fw_soft_story_d: "Πουλά μέσα από προσωπική ιστορία",
    fw_comparison: "Σύγκριση Περιπτώσεων",
    fw_comparison_d: "Συγκρίνει πριν/μετά ή εναλλακτικές",
    fw_objection: "Διαχείριση Αντιρρήσεων",
    fw_objection_d: "Απαντά στις αντιρρήσεις του κοινού",
    fw_direct_sale: "Άμεση Επιθετική Πώληση",
    fw_direct_sale_d: "Απευθείας και επιθετική πώληση",
    fw_belief_shift: "Αλλαγή Πεποίθησης",
    fw_belief_shift_d: "Αλλάζει την πεποίθηση του αναγνώστη",
    fw_pas: "Πρόβλημα-Ένταση-Λύση",
    fw_pas_d: "Εντοπίζει, μεγεθύνει και λύνει το πρόβλημα",
    fw_social_proof: "Στοίβα Κοινωνικής Απόδειξης",
    fw_social_proof_d: "Χτίζει με μαρτυρίες και αποτελέσματα",
    fw_fomo: "Φόβος Απώλειας (FOMO)",
    fw_fomo_d: "Δημιουργεί επείγον και φόβο απώλειας",
    fw_value_ladder: "Κλίμακα Αξίας",
    fw_value_ladder_d: "Δείχνει προοδευτική αξία και αναβάθμιση",
    fw_dream_outcome: "Ονειρεμένο Αποτέλεσμα",
    fw_dream_outcome_d: "Οραματίζεται το ιδανικό αποτέλεσμα",
    fw_curiosity_gap: "Χάσμα Περιέργειας",
    fw_curiosity_gap_d: "Δημιουργεί περιέργεια που πρέπει να κλείσει",
    fw_transformation: "Ιστορία Μετασχηματισμού",
    fw_transformation_d: "Δείχνει το ταξίδι αλλαγής",
    // Funnel tags for badges
    funnel_top: "Κορυφή διοχέτευσης",
    funnel_mid: "Μέση διοχέτευσης",
    funnel_bottom: "Βάση διοχέτευσης",
    step5_title: "Ύφος & αισθητική",
    step5_sub: "Φωνή και στυλ σχεδίασης.",
    // 6 tones with fresh names, same spirit
    tone_trailblazer: "Ρηξικέλευθος",
    tone_guide: "Καθοδηγητής",
    tone_maverick: "Ατίθασος",
    tone_elite_ceo: "Κορυφαίος CEO",
    tone_analytical: "Αναλυτικός",
    tone_coach: "Προπονητής",
    tone_label: "Τόνος φωνής",
    design_label: "Στυλ σχεδίασης",
    // 11 design styles (same names as reference)
    design_none: "Κανένας",
    design_shruti: "Στυλ Shruti",
    design_hormozi: "Στυλ Hormozi",
    design_gary_vee: "Στυλ Gary Vee",
    design_alex_catoni: "Στυλ Alex Cattoni",
    design_marie_forleo: "Στυλ Marie Forleo",
    design_devin_jatho: "Στυλ Devin Jatho",
    design_dain_walker: "Στυλ Dain Walker",
    design_chris_do: "Στυλ Chris Do",
    design_marketing_harry: "Στυλ Marketing Harry",
    design_custom: "Δικό μου στυλ",
    step6_title: "Γλώσσα & Format",
    step6_sub: "Επίλεξε γλώσσα και μέγεθος slide.",
    lang_el: "Ελληνικά",
    lang_en: "English",
    format_label: "Format",
    // Editor
    editor_slides: "Slides",
    editor_props: "Ιδιότητες",
    editor_content: "Περιεχόμενο post",
    caption_short: "Σύντομη λεζάντα",
    caption_seo: "SEO λεζάντα",
    hashtags: "Hashtags",
    alt_hooks: "Εναλλακτικά hooks",
    alt_ctas: "Εναλλακτικά CTAs",
    copy: "Αντιγραφή",
    copied: "Αντιγράφηκε",
    download_png: "PNG",
    download_zip: "ZIP",
    download_pdf: "PDF",
    back_dashboard: "Πίσω",
    bg: "Φόντο",
    accent: "Τόνος",
    text_color: "Κείμενο",
    text_position: "Θέση",
    text_align: "Στοίχιση",
    font_weight: "Βάρος",
    font_size: "Μέγεθος",
    font_family_label: "Γραμματοσειρά",
    effect: "Εφέ",
    add_slide: "Προσθήκη slide",
    // Recreate
    recreate_title: "Αναδημιουργία post",
    recreate_sub: "Επικόλλησε ένα υπάρχον post και θα το ξαναγράψουμε σε καρουζέλ.",
    recreate_cta: "Αναδημιουργία",
    paste_here: "Επικόλλησε εδώ…",
    // History
    history_title: "Ιστορικό",
    history_sub: "Όλα σου τα καρουζέλ σε ένα μέρος.",
    open: "Άνοιγμα",
    delete: "Διαγραφή",
    confirm_delete: "Σίγουρα διαγραφή;",
  },
  en: {
    nav_create: "New carousel",
    nav_recreate: "Recreate",
    nav_history: "History",
    brand_tag: "Carousel Studio",
    hero_kicker: "AI CO-WRITER FOR CREATORS",
    hero_title_1: "Carousels that stop",
    hero_title_2: "the scroll.",
    hero_sub: "Type your brief — get a ready-to-post Instagram carousel with hooks, captions and CTAs in Greek or English.",
    cta_create: "Start from scratch",
    cta_recreate: "Recreate a post",
    section_latest: "Latest carousels",
    empty_history_title: "Nothing here yet.",
    empty_history_sub: "Hit \"Start from scratch\" to see the studio in action.",
    wizard_step_of: "Step",
    wizard_of: "of",
    wizard_back: "Back",
    wizard_next: "Continue",
    wizard_generate: "Generate carousel",
    generating: "Generating…",
    step1_title: "Describe your offer",
    step1_sub: "The more specific, the stronger the content.",
    step1_placeholder: "e.g. Online yoga classes for professionals who work 10+ hours and wake up with back pain — 15 min/day, no equipment…",
    step1_price: "Price tier",
    step1_price_low: "Low",
    step1_price_mid: "Mid",
    step1_price_high: "High",
    step2_title: "DM trigger & slide count",
    step2_sub: "Set a keyword for comments/DM and how many slides.",
    step2_keyword: "Keyword (optional)",
    step2_keyword_ph: "e.g. YOGA",
    step2_slides: "Number of slides",
    step2_boost: "Conversion boost",
    step2_boost_desc: "Tightens the hook and CTA.",
    step3_title: "Who's your audience?",
    step3_sub: "Age, desires, pain points, stage — whatever you know.",
    step3_placeholder: "e.g. Professionals 30–50 who work from home, feel stressed and stiff after lockdown, looking for something they can do before work…",
    step3_funnel: "Funnel stage",
    step3_new: "New audience",
    step3_warm: "They already know me",
    step3_hot: "Ready to buy",
    step4_title: "Pick your framework",
    step4_sub: "15 proven psychological frameworks. Each has its own conversion structure.",
    fw_pattern_interrupt: "Pattern Interrupt",
    fw_pattern_interrupt_d: "Stops the scroll with a bold claim",
    fw_myth_busting: "Myth Busting",
    fw_myth_busting_d: "Dismantles common misconceptions",
    fw_authority: "Authority Builder",
    fw_authority_d: "Builds trust and credibility",
    fw_soft_story: "Soft Narrative Sale",
    fw_soft_story_d: "Sells through personal story",
    fw_comparison: "Case Comparison",
    fw_comparison_d: "Before/after or alternatives",
    fw_objection: "Objection Handling",
    fw_objection_d: "Answers buyer objections",
    fw_direct_sale: "Direct Aggressive Sale",
    fw_direct_sale_d: "Straight-up, benefit-stacked offer",
    fw_belief_shift: "Belief Shift",
    fw_belief_shift_d: "Reframes reader's belief",
    fw_pas: "Problem · Agitate · Solution",
    fw_pas_d: "Find, amplify, solve a pain",
    fw_social_proof: "Social Proof Stack",
    fw_social_proof_d: "Testimonials and results",
    fw_fomo: "FOMO",
    fw_fomo_d: "Urgency and fear of missing out",
    fw_value_ladder: "Value Ladder",
    fw_value_ladder_d: "Progressive value and upgrade",
    fw_dream_outcome: "Dream Outcome",
    fw_dream_outcome_d: "Paints the ideal after-state",
    fw_curiosity_gap: "Curiosity Gap",
    fw_curiosity_gap_d: "Creates irresistible curiosity",
    fw_transformation: "Transformation Story",
    fw_transformation_d: "Journey from struggle to win",
    funnel_top: "Top of funnel",
    funnel_mid: "Middle of funnel",
    funnel_bottom: "Bottom of funnel",
    step5_title: "Tone & aesthetic",
    step5_sub: "Voice and visual style.",
    tone_trailblazer: "Trailblazer",
    tone_guide: "Guide",
    tone_maverick: "Maverick",
    tone_elite_ceo: "Elite CEO",
    tone_analytical: "Analytical",
    tone_coach: "Coach",
    tone_label: "Tone of voice",
    design_label: "Design style",
    design_none: "None",
    design_shruti: "Shruti style",
    design_hormozi: "Hormozi style",
    design_gary_vee: "Gary Vee style",
    design_alex_catoni: "Alex Cattoni style",
    design_marie_forleo: "Marie Forleo style",
    design_devin_jatho: "Devin Jatho style",
    design_dain_walker: "Dain Walker style",
    design_chris_do: "Chris Do style",
    design_marketing_harry: "Marketing Harry style",
    design_custom: "My own style",
    step6_title: "Language & Format",
    step6_sub: "Pick a language and slide size.",
    lang_el: "Greek",
    lang_en: "English",
    format_label: "Format",
    editor_slides: "Slides",
    editor_props: "Properties",
    editor_content: "Post content",
    caption_short: "Short caption",
    caption_seo: "SEO caption",
    hashtags: "Hashtags",
    alt_hooks: "Alt hooks",
    alt_ctas: "Alt CTAs",
    copy: "Copy",
    copied: "Copied",
    download_png: "PNG",
    download_zip: "ZIP",
    download_pdf: "PDF",
    back_dashboard: "Back",
    bg: "Background",
    accent: "Accent",
    text_color: "Text",
    text_position: "Position",
    text_align: "Align",
    font_weight: "Weight",
    font_size: "Size",
    font_family_label: "Font",
    effect: "Effect",
    add_slide: "Add slide",
    recreate_title: "Recreate a post",
    recreate_sub: "Paste an existing post and we'll remix it into a carousel.",
    recreate_cta: "Recreate",
    paste_here: "Paste here…",
    history_title: "History",
    history_sub: "All your carousels in one place.",
    open: "Open",
    delete: "Delete",
    confirm_delete: "Delete this carousel?",
  },
};

const I18nContext = createContext({ lang: "el", setLang: () => {}, t: (k) => k });

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("cs_lang") || "el");
  const value = useMemo(() => ({
    lang,
    setLang: (l) => {
      setLang(l);
      localStorage.setItem("cs_lang", l);
    },
    t: (k) => (dict[lang] && dict[lang][k]) || (dict.en[k]) || k,
  }), [lang]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
